import React from 'react'

import { Card, CardContent } from '../../../global/components/ui/card.jsx'
import DocumentAccordion from './DocumentAccordion.jsx'
import { formatDate } from '../utils/documentUtils.js'

const DocumentsList = ({
  requestTask,
  documents,
  dragOverDocId,
  setDragOverDocId,
  onDragFiles,
  onDeleteFile,
  unmatchedFiles,
}) => {
  const otherDocument = {
    id: 'unmatched',
    custom_name: 'Other',
    name: 'Other / Unmatched Files',
    files: unmatchedFiles || [],
    isOther: true,
  }

  const isRequestRejected = requestTask.status === 'rejected'

  const filteredDocuments = isRequestRejected
    ? documents.filter(
        doc =>
          doc.status === 'pending_reupload' || doc.status === 'pending_upload',
      )
    : documents

  const requiredDocuments = filteredDocuments.filter(
    doc => doc.settings?.number_of_files > 0,
  )

  const allDocumentsFulfilled =
    requiredDocuments.length > 0 &&
    requiredDocuments.every(
      doc =>
        (doc.files?.length || 0) >= doc.settings.number_of_files &&
        doc.status !== 'pending_reupload',
    )

  const allDocuments = [...filteredDocuments, otherDocument]

  return (
    <>
      <div className="tw-mb-4 tw-mt-8 tw-flex tw-items-center tw-justify-between tw-gap-4">
        <div>
          <h3 className="tw-m-0">Requested Documents</h3>

          {allDocumentsFulfilled && (
            <p className="tw-mb-0 tw-mt-1">
              All requested documents are fulfilled and ready for submission
            </p>
          )}
        </div>
        {requestTask.documents_range_to_date && (
          <p className="tw-mb-0 tw-shrink-0 tw-text-sm">
            <strong>From:</strong>{' '}
            {formatDate(requestTask.documents_range_from_date)} |{' '}
            <strong>To:</strong>{' '}
            {formatDate(requestTask.documents_range_to_date)}
          </p>
        )}
      </div>
      <Card className="tw-mt-6 tw-shadow-none">
        <CardContent className="tw-p-4">
          <div className="tw-grid tw-gap-4 sm:tw-grid-cols-2">
            {allDocuments.map(doc => (
              <DocumentAccordion
                key={doc.id || `custom-${doc.custom_name}`}
                doc={doc}
                dragOverDocId={dragOverDocId}
                setDragOverDocId={setDragOverDocId}
                onDragFiles={onDragFiles}
                onDeleteFile={onDeleteFile}
              />
            ))}
          </div>
        </CardContent>
      </Card>

      {requestTask.special_instructions && (
        <div className="tw-mt-2 tw-py-4 tw-pr-4">
          <h5 className="tw-m-0">
            <strong>Special Instructions</strong> :{' '}
            {requestTask.special_instructions}
          </h5>
        </div>
      )}
    </>
  )
}

export default DocumentsList
